import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
// import { amber, green } from '@mui/material/colors';
import IconButton from "@mui/material/IconButton";
import SnackbarContent from "@mui/material/SnackbarContent";
import WarningIcon from "@mui/icons-material/Warning";
import classes from "./SnackBarsComponent.module.scss";
// import { makeStyles } from '@mui/material/styles';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const MySnackbarContentWrapper = forwardRef(function MySnackbarContentWrapper(
  props,
  ref
) {
  const { className, message, onClose, variant, contentClassName, ...other } =
    props;
  const Icon = variantIcon[variant];

  const actionButton = (
    <IconButton
      key="close"
      aria-label="close"
      color="inherit"
      onClick={onClose}
    >
      <CloseIcon className={classes.icon} />
    </IconButton>
  );

  return (
    <SnackbarContent
      ref={ref}
      className={clsx(classes[variant], className, contentClassName)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={clsx(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={actionButton}
      {...other}
    />
  );
});

export default forwardRef(function Snackbars(props, ref) {
  return (
    <MySnackbarContentWrapper
      ref={ref}
      variant={props.variant}
      className={classes.margin}
      message={props.message}
      onClose={props.handleClose}
      contentClassName={props.contentClassName} // <-- nueva prop
    />
  );
});
